import { createFileRoute } from "@tanstack/react-router";

import { ErrorInternal } from "@/components/error-internal";

export const Route = createFileRoute("/(auth)/403")({
  component: ErrorInternal,
});
